"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useVybeAgentChat } from "@/components/desktop/agent/useVybeAgentChat";
import type { AgentChatApi } from "./agent-chat-types";

const AgentChatContext = createContext<AgentChatApi | null>(null);

/** Persists Vybe Agent chat session for mobile overlay open/close. */
export function AgentChatProvider({ children }: { children: ReactNode }) {
  const chat = useVybeAgentChat();
  return (
    <AgentChatContext.Provider value={chat}>{children}</AgentChatContext.Provider>
  );
}

export function useAgentChat(): AgentChatApi {
  const ctx = useContext(AgentChatContext);
  if (!ctx) {
    throw new Error("useAgentChat must be used within AgentChatProvider");
  }
  return ctx;
}
